import React from "react";

export default function Terms() {
  return (
    <div className="container mt-3">
      <h1 className="headline_text">TERMS OF USE</h1>
      <div className="text-left mt-3 content_style">
        <div>
          <h2 className="global_text_color mb-3">1. About the terms</h2>
          <p className="global_text_color mb-1">
            The terms of this agreement (“Terms of Use”) govern the relationship
            between you and DEVOTED HORSES, websites and related services (the
            “Servece”) including all information, text, graphics, software, and
            services, available for your use. Use of the Service is also
            governed by Privacy Policy and other relevant policies, which are
            incorporated herein by reference.
          </p>
          <p className="global_text_color mb-1">
            By using this website and the services offered on it, downloading
            any software, or browsing the website, as well as by downloading any
            of DEVOTED HORSES games from (such as the Apple App Store, Google
            Play Store, Amazon App Store, Windows Phone Store, or any other
            websites), you accept the following Terms Of Use and our Privacy
            Policy.
          </p>
          <p className="global_text_color mb-1">
            If you do not agree to these Terms of Use or any future updated
            version of them then you must not access and/or use, and must cease
            all access and/or use of, any of our Services. If we require that
            any future update to these terms requires any action from you in
            order to accept the updated terms, then you may not be able to
            continue to use the Services until you have taken such action.
          </p>
          <p className="global_text_color mb-1">
            DEVOTED HORSES is authorized to amend the Terms of Use at any time,
            with the amended Terms of Use effective as soon as they are posted
            on this website. Please check the most current Terms of Use to
            ensure that you are aware of all the terms and conditions regulating
            your use of this website and DEVOTED HORSES games.
          </p>
          <p className="global_text_color mb-1">
            DEVOTED HORSES reserves the right, at its discretion, to change,
            modify, add or remove portions of these Terms of Use at any time and
            without any notice. DEVOTED HORSES reserves the right to terminate
            or restrict access to the website and games for any reason
            whatsoever at its sole discretion.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">
            2. Accessing and using our Services
          </h2>
          <p className="global_text_color mb-1">
            You are responsible for the internet connection and/or mobile
            charges that you may incur for accessing and/or using our Services.
            You should ask your mobile operator or internet service provider if
            you are unsure what these charges will be, before you access and/or
            use our Services.
          </p>
          <p className="global_text_color mb-1">
            For Services , you agree that you are at least 13 years old and that
            if you are between 13 years and 18 years old, your legal guardian
            has reviewed and agrees to these terms and is happy for you to
            access and/or use our Services.
          </p>
          <p className="global_text_color mb-1">
            Downloading and use any of the software or services offered on this
            website is done at your own discretion and risk and you are solely
            responsible for all damage to your device system, loss of data, or
            other harm that results form such activities.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">3. Accounts</h2>
          <p className="global_text_color mb-1">
            When using our Services you may choose to, and in some instances you
            will be required to, create an account with us. If you access the
            Service from a Social Networking Site ("SNS"), such as Facebook or
            Google+, you shall comply with its terms of service/use as well as
            these Terms of Service. If you do create an account with us, you
            agree that you shall take all steps necessary to protect your log in
            details and keep them secret.
          </p>
          <p className="global_text_color mb-1">
            You agree that you shall not give your log in details to anyone else
            or allow anyone else to use your log in details or account.We will
            not be responsible to you for any loss that you suffer as a result
            of an unauthorised person accessing your account and/or using our
            Services and we accept no responsibility for any losses or harm
            resulting from its unauthorised use, whether fraudulently or
            otherwise.
          </p>
          <p className="global_text_color mb-1">
            YOU ACKNOWLEDGE AND AGREE THAT YOU SHALL HAVE NO OWNERSHIP OR OTHER
            PROPERTY INTEREST IN ANY ACCOUNT THAT YOU CREATE USING ANY OF OUR
            SERVICES. WE MAY SUSPEND, TERMINATE, MODIFY OR DELETE ANY OF THESE
            ACCOUNTS AT ANY TIME FOR ANY REASON OR NO REASON, WITH OR WITHOUT
            NOTICE TO YOU.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">4. Fees and Purchase Terms</h2>
          <p className="global_text_color mb-1">
            DEVOTED HORSES’s mobile and social games include virtual in-game
            currency (“Virtual Currency”), such as coins, cash, gems, and/or
            diamonds, that can be purchased for real money and in turn used to
            purchase virtual in-game items (“Virtual Items”) or paid
            subscriptions for Virtual Currency and/or Virtual Items
            (“Subscriptions”). Please note that DEVOTED HORSES does not handle
            and is not responsible for handling transactions acquiring Virtual
            Currency. All Virtual Currency transactions are handled by
            third-party e-commerce payment providers. By purchasing in-game
            Virtual Currency, you are bound by and agree to the third-party
            payment providers’ Terms of Use.
          </p>
          <p className="global_text_color mb-1">
            You agree that once purchased Virtual Currency, Virtual Items and/or
            Subscriptions have no monetary value and can never be exchanged for
            real money, real goods or real services from us or anyone else. You
            agree that Virtual Currency, Virtual Items and/or Subscriptions are
            not transferrable to anyone else and you will not transfer or
            attempt to transfer any Virtual Currency, Virtual Items and/or
            Subscriptions to anyone else.
          </p>
          <p className="global_text_color mb-1">
            DEVOTED HORSES may manage, regulate, control, modify or eliminate
            Virtual Currency, Virtual Items and/or Subscriptions at any time,
            with or without notice. DEVOTED HORSES shall have no liability to
            you or any third party in the event that DEVOTED HORSES exercises
            any such rights.
          </p>
          <p className="global_text_color mb-1">
            YOU AGREE THAT ALL SALES BY US TO YOU OF VIRTUAL CURRENCY AND/OR
            VIRTUAL ITEMS ARE FINAL, THAT WE WILL NOT REFUND ANY TRANSACTION
            ONCE IT HAS BEEN MADE AND THAT AN ACTIVE SUBSCRIPTION CANNOT BE
            CANCELLED DURING THE SUBSCRIPTION PERIOD.
          </p>
          <p className="global_text_color mb-1">
            You agree to pay all fees and applicable taxes incurred by you or
            anyone using an Account registered to you. We may revise the pricing
            for the Virtual Currency and Virtual Items offered through the
            Service at any time. YOU ACKNOWLEDGE THAT DEVOTED HORSES IS NOT
            REQUIRED TO PROVIDE A REFUND FOR ANY REASON, AND THAT YOU WILL NOT
            RECEIVE MONEY OR OTHER COMPENSATION FOR UNUSED VIRTUAL ITEMS WHEN AN
            ACCOUNT IS CLOSED, WHETHER SUCH CLOSURE WAS VOLUNTARY OR
            INVOLUNTARY.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">
            5. Copyright and Trademarks
          </h2>
          <p className="global_text_color mb-1">
            Copyrights, trademarks, and all other proprietary rights shown in
            the content (including, but not limited to, software, games,
            services, computer code, text, themes, characters, character names,
            stories, dialogue, documentation, animations, sounds, graphics, and
            logos) are reserved to DEVOTED HORSES and protected by international
            copyright laws. You agree not to copy, republish, modify, download,
            distribute, license, sublicense, reverse engineer, or create
            derivatives based on the site, its software, or its services except
            as expressly authorized herein. Any other use of the content,
            including, without limitation, distribution, reproduction,
            modification, display, or transmission, without the prior written
            consent of DEVOTED HORSES is strictly prohibited. All copyright and
            other proprietary notices shall be retained on all reproductions.
            DEVOTED HORSES reserves all rights, including without limitation,
            all intellectual property rights or other proprietary rights, in
            connection with its games and the Service.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">6. Disclaimer of Warranty</h2>
          <p className="global_text_color mb-1">
            DEVOTED HORSES has no special relationship with or fiduciary duty to
            you. You acknowledge that company has no control over, and no duty
            to take any action regarding: which users gain access to the
            Software and/or Games; what content you access via the Software
            and/or Games; what effects the Software and/or Games or the content
            accessed therein may have on you; how you may interpret or use the
            content accessed via the Software and/or Games; or what actions you
            may take as a result of having been exposed to the Software and/or
            Games. You release company from all liability for you having
            acquired or not acquired content through the Software and/or Games.
            DEVOTED HORSES makes no representations concerning any content
            contained in or accessed through the Software and/or Games, and
            company will not be responsible or liable for the accuracy,
            copyright compliance, legality or decency of material contained in
            or accessed through the Software.
          </p>
          <p className="global_text_color mb-1">
            Downloading and using any of the software, games or services offered
            on the website is done at your own discretion and risk and your are
            solely responsible for all damage to your device system, lost of
            data, or other harm that results from such activities.
          </p>
          <p className="global_text_color mb-1">
            ALL INFORMATION, SOFTWARE, GAMES, AND SERVICES OFFERED ON THIS
            WEBSITE ARE PROVIDED "AS IS." DEVOTED HORSES HEREBY EXPRESSLY
            DISCLAIMS ALL WARRANTIES OF ANY KIND, EXPRESSED OR IMPLIED,
            INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">
            7. Limitations of Liability
          </h2>
          <p className="global_text_color mb-1">
            In no event shall DEVOTED HORSES be liable for any loss or damages
            (including without limitation of any direct, indirect, punitive,
            special, incidental or consequential loss or damage):
          </p>
          <ul>
            <li className="global_text_color mb-1">
              Access to the Service or inability to access to the Service;
            </li>
            <li className="global_text_color mb-1">
              Any third party's conduct, content, information or data;
            </li>
            <li className="global_text_color mb-1">
              Any unauthorized access to or use of DEVOTED HORSES Services
              and/or any and all personal, private, and/ or other information
              stored therein;
            </li>
            <li className="global_text_color mb-1">
              Losses or harm not caused by our breach of these terms or
              negligence;
            </li>
            <li className="global_text_color mb-1">
              Losses or harm which are not reasonably foreseeable by you and us
              at the time of you agreeing to these terms and conditions
              including those losses which happen as a side effect of
              foreseeable losses. This could include loss of data, loss of
              opportunity, service interruption, computer or other device
              failure or financial loss;
            </li>
            <li className="global_text_color mb-1">
              Any damage that may be caused to any device on which you access or
              use any of our Games or other Services that is caused in any way
              by our Services unless that damage is directly caused by our
              failure to exercise reasonable skill and care in the provision of
              the applicable Games or other Services;
            </li>
            <li className="global_text_color mb-1">
              Any increase in loss or damage resulting from breach by you of any
              of these terms and conditions; or
            </li>
            <li className="global_text_color mb-1">
              Technical failures or the lack of availability of any of our
              Services where these are not within our reasonable control.
            </li>
          </ul>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">8. Supplemental Policies</h2>
          <p className="global_text_color mb-1">
            DEVOTED HORSES may publish additional policies related to specific
            services (including but not limited to forums, contests, or loyalty
            programs). Your right to use such services is subject to those
            specific policies and these Terms of Use.
          </p>
        </div>
        <div className="mt-3">
          <h2 className="global_text_color mb-3">9. Thank You</h2>
          <p className="global_text_color mb-1">
            Thank you for reading our Terms. Hope you enjoy playing DEVOTED
            HORSES’s games!
          </p>
        </div>
      </div>
    </div>
  );
}
